import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuardService} from '@Services/auth';
import {ForbiddenComponent} from '@Common/forbidden/forbidden.component';
import {AccueilComponent} from './accueil/accueil.component';
import {ReponseFicheComponent} from './gestion/reponses/reponse-fiche/reponse-fiche.component';

const appRoutes: Routes = [
  {
    path: '',
    children: [
      {path: '', component: AccueilComponent, canActivate: [AuthGuardService]},
      {path: 'demande/visualiser/:uuid', component: ReponseFicheComponent},
      {path: 'demande/visualiser-sollicite/:uuid', component: ReponseFicheComponent},
      {path: 'demande/visualiser/:uuid/:message', component: ReponseFicheComponent},
      {path: 'demandeur', loadChildren: () => import('./demandeur/demandeur.module').then(m => m.DemandeurModule)},
      {path: 'opinions', loadChildren: () => import('./opinion/opinion.module').then(m => m.OpinionModule)},
      {path: 'admin', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)},
      {path: 'gestion', loadChildren: () => import("./gestion/gestion.module").then((m) => m.GestionModule)},
    ]
  },
  {path: 'forbidden', component: ForbiddenComponent},
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {})
  ],
  exports: [
    RouterModule,
  ]
})
export class AppRoutingModule {
}
